import * as React from "react";
import {
  Link,
  Toast,
  ToastTitle,
  ToastBody,
  ToastFooter,
  Spinner,
} from "@fluentui/react-components";

export const WarningToast = ({ message, subtitle }) => {
  return (
    <Toast>
      <ToastTitle>Atencao</ToastTitle>
      <ToastBody subtitle={subtitle}>{message}</ToastBody>
    </Toast>
  );
};

export const SuccessToast = ({ message, subtitle }) => {
  return (
    <Toast>
      <ToastTitle>Sucesso</ToastTitle>
      <ToastBody subtitle={subtitle}>{message}</ToastBody>
    </Toast>
  );
};

export const ProgressToast = ({ message, body, subtitle }) => {
  return (
    <Toast>
      <ToastTitle media={<Spinner size="tiny" />}>{message}</ToastTitle>
      <ToastBody subtitle={subtitle}>{body}</ToastBody>
    </Toast>
  );
};
